import ImageCollectionPage from "../components/ImageCollectionPage";

export default function History() {
  return (
    <ImageCollectionPage 
      title="History of D.R.Y" 
      path="/history" 
      collection="history" 
    />
  );
}
